// formuläret från startsidan (genvägen) det förenklade
import { connect } from "react-redux";
import axios from "axios";
import { getUndersokning } from "./actions";
import  { infraConfig } from "config/infraConfig";
import { getAxiosConfig } from "system/axiosConfig";
import SavingButton from "components/CustomButtons/SavingButton.jsx"
import Datetime from "react-datetime";
import React, { Component} from "react";
import {
    FormGroup,
    FormControl,
    ControlLabel,
    Radio,
  } from "react-bootstrap";

  import moment from 'moment';
  import 'moment/locale/sv';


class Tjansteman extends Component {

    constructor(props){
        super(props);

        moment().locale('sv');

        this.state = { validated: false };
        this.state = this.getInititalState();

        this.handleFormSave = this.handleFormSave.bind(this);
        this.arbetsmiljo1IsValid = false;
        this.arbetsmiljo4IsValid = false;
        this.arbetsmiljo5IsValid = false;
        this.arbetsmiljo6IsValid = false;
        this.arbetsmiljo7IsValid = false;
        this.arbetsmiljo8IsValid = false;

        this.arbetstriv3IsValid = false;
        this.arbetstriv4IsValid = false;
        this.arbetstriv5IsValid= false;
        this.arbetstriv6IsValid = false;

        this.ledarskapet4IsValid= false;
        this.ledarskapet5IsValid = false;
        this.ledarskapet6IsValid = false;
        this.ledarskapet7IsValid = false;

        this.arbetsuppgifter1IsValid = false;
        this.arbetsuppgifter4IsValid = false;
        this.arbetsuppgifter5IsValid= false;

        this.information3IsValid = false;
        this.information4IsValid = false;
        this.information6IsValid = false;
        this.information7IsValid = false;

        this.kunder1IsValid = false;
        this.kunder2IsValid = false;
        this.kunder3IsValid = false;
        this.kunder4IsValid = false;

        this.foretaget1IsValid = false;
        this.foretaget2IsValid = false;
      }
      handleFormSave() {
        if(!this.arbetsmiljo1IsValid){this.setState({arbetsmiljo1Error:   'Måste anges'});}
        if(!this.arbetsmiljo4IsValid){this.setState({arbetsmiljo4Error:   'Måste anges'});}
        if(!this.arbetsmiljo5IsValid){this.setState({arbetsmiljo5Error:   'Måste anges'});}
        if(!this.arbetsmiljo6IsValid){this.setState({arbetsmiljo6Error:   'Måste anges'});}
        if(!this.arbetsmiljo7IsValid){this.setState({arbetsmiljo7Error:   'Måste anges'});}
        if(!this.arbetsmiljo8IsValid){this.setState({arbetsmiljo8Error:   'Måste anges'});}

        if(!this.arbetstriv3IsValid){this.setState({arbetstriv3Error:   'Måste anges'});}
        if(!this.arbetstriv4IsValid){this.setState({arbetstriv4Error:   'Måste anges'});}
        if(!this.arbetstriv5IsValid){this.setState({arbetstriv5Error:   'Måste anges'});}
        if(!this.arbetstriv6IsValid){this.setState({arbetstriv6Error:   'Måste anges'});}

        if(!this.ledarskapet4IsValid){this.setState({ledarskapet4Error:   'Måste anges'});}
        if(!this.ledarskapet5IsValid){this.setState({ledarskapet5Error:   'Måste anges'});}
        if(!this.ledarskapet6IsValid){this.setState({ledarskapet6Error:   'Måste anges'});}
        if(!this.ledarskapet7IsValid){this.setState({ledarskapet7Error:   'Måste anges'});}

        if(!this.arbetsuppgifter1IsValid){this.setState({arbetsuppgifter1Error:   'Måste anges'});}
        if(!this.arbetsuppgifter4IsValid){this.setState({arbetsuppgifter4Error:   'Måste anges'});}
        if(!this.arbetsuppgifter5IsValid){this.setState({arbetsuppgifter5Error:   'Måste anges'});}

        if(!this.information3IsValid){this.setState({information3Error:   'Måste anges'});}
        if(!this.information4IsValid){this.setState({information4Error:   'Måste anges'});}
        if(!this.information6IsValid){this.setState({information6Error:   'Måste anges'});}
        if(!this.information7IsValid){this.setState({information7Error:   'Måste anges'});}

        if(!this.kunder1IsValid){this.setState({kunder1Error:   'Måste anges'});}
        if(!this.kunder2IsValid){this.setState({kunder2Error:   'Måste anges'});}
        if(!this.kunder3IsValid){this.setState({kunder3Error:   'Måste anges'});}
        if(!this.kunder4IsValid){this.setState({kunder4Error:   'Måste anges'});}

        if(!this.foretaget1IsValid){this.setState({foretaget1Error:   'Måste anges'});}
        if(!this.foretaget2IsValid){this.setState({foretaget2Error:   'Måste anges'});}

        if (this.arbetsmiljo1IsValid
        && this.arbetsmiljo4IsValid
        && this.arbetsmiljo5IsValid
        && this.arbetsmiljo6IsValid
        && this.arbetsmiljo7IsValid
        && this.arbetsmiljo8IsValid
        && this.arbetsmiljo1IsValid
        && this.arbetsmiljo1IsValid

        && this.arbetstriv3IsValid
        && this.arbetstriv4IsValid
        && this.arbetstriv5IsValid
        && this.arbetstriv6IsValid

        && this.ledarskapet4IsValid
        && this.ledarskapet5IsValid
        && this.ledarskapet6IsValid
        && this.ledarskapet7IsValid

        && this.arbetsuppgifter1IsValid
        && this.arbetsuppgifter4IsValid
        && this.arbetsuppgifter5IsValid

        && this.information3IsValid
        && this.information4IsValid
        && this.information6IsValid
        && this.information7IsValid

        && this.kunder1IsValid
        && this.kunder2IsValid
        && this.kunder3IsValid
        && this.kunder4IsValid

        && this.foretaget1IsValid
        && this.foretaget2IsValid
        )
        {
            var saveData = {
                arbetsmiljo1: this.state.arbetsmiljo1,
                arbetsmiljo4: this.state.arbetsmiljo4,
                arbetsmiljo5: this.state.arbetsmiljo5,
                arbetsmiljo6: this.state.arbetsmiljo6,
                arbetsmiljo7: this.state.arbetsmiljo7,
                arbetsmiljo8: this.state.arbetsmiljo8,
                arbetsmiljo9: this.state.arbetsmiljo9,

                arbetstriv3: this.state.arbetstriv3,
                arbetstriv4: this.state.arbetstriv4,
                arbetstriv5: this.state.arbetstriv5,
                arbetstriv6: this.state.arbetstriv6,
                arbetstriv7: this.state.arbetstriv7,

                ledarskapet4: this.state.ledarskapet4,
                ledarskapet5: this.state.ledarskapet5,
                ledarskapet6: this.state.ledarskapet6,
                ledarskapet7: this.state.ledarskapet7,
                ledarskapet8: this.state.ledarskapet8,

                arbetsuppgifter1: this.state.arbetsuppgifter1,
                arbetsuppgifter4: this.state.arbetsuppgifter4,
                arbetsuppgifter5: this.state.arbetsuppgifter5,
                arbetsuppgifter6: this.state.arbetsuppgifter6,

                information3: this.state.information3,
                information4: this.state.information4,
                information5: this.state.information5,
                information6: this.state.information6,
                information7: this.state.information7,

                kunder1: this.state.kunder1,
                kunder2: this.state.kunder2,
                kunder3: this.state.kunder3,
                kunder4: this.state.kunder4,
                kunder5: this.state.kunder5,

                foretaget1: this.state.foretaget1,
                foretaget2: this.state.foretaget2,
                foretaget3: this.state.foretaget3,
                foretaget4: this.state.foretaget4,

                utvecklingsprojekt1: this.state.utvecklingsprojekt1,
                
                kortfri1: this.state.kortfri1,
            
            };
           console.log(saveData);
        this.addUtvardering(saveData);
         }
         else{
            this.setState({buttonerror:   'Alla fält har inte fyllts i'});
    console.log("Error")
       }

    }
addUtvardering(saveData) {
    this.setState({buttonerror:   ''});
  console.log("Send!")
  this.setState({
      savingStatus: 1
  }, () => {

      axios.post(infraConfig.apiEndpoint.concat('/api/undersokning/send'), saveData, getAxiosConfig(this.props.user))
      .then((dataResult) => {
          console.log('after send success', dataResult.data.result);
          this.setState({buttonmessage:   dataResult.data.result})
          if(dataResult.data.result == "Du har redan skickat in ett svar."){
            this.setState({buttonerror2:  "Du har redan skickat in ett svar."});
            this.setState({
                savingStatus: 3
            });

          }
          else{
          this.setState({
              savingStatus: 2
          });
        }
          this.resetForm();
      })
      .catch((error) => {
        this.setState({buttonerror2:  "Ett fel inträffade"});
          this.setState({
              savingStatus: 3
          });
          console.log('ERROR');
         });
  });

}
resetForm() {
  var savingStatus = this.state.savingStatus;
  this.setState(this.getInititalState(), () => {
     this.setState({ savingStatus: savingStatus});
  });


    document.getElementById("create-forare").reset();
}
  getInititalState = () => {
    const initialState = {
        datumError: null,
        val1Error: null,
        arbetsmiljo1: '',

        savingStatus: 0
    }
    return initialState;
  }

render() {
    return (

<div id="content">
 
<p>Engagerade och motiverade medarbetare är helt avgörande för företagets framgång. Vi strävar därför efter att skapa en bra arbetsmiljö där medarbetare trivs och känner sig delaktiga. Vi genomför vartannat år en större medarbetarundersökning med syfte att ta reda på hur våra medarbetare uppfattar sin arbetssituation och Byberg & Nordin / Docksta Buss & Truck som arbetsgivare, och nu är det dags igen. Undersökningen kommer att pågå till och med den 30 september. Målet med undersökningen är att den ska resultera i förslag på utvecklingsområden och hjälpa företaget att prioritera förbättringsinsatser framåt. Använd gärna fritextrutorna för att förtydliga och vidareutveckla dina svar på kryssfrågorna.</p>
    <p>Tack för din medverkan!</p>
    <p>Tomas Byberg, ägare/vd Byberg & Nordin</p>
    <form
      id="create-forare"
       >   
           <h2>Arbetsmiljö</h2>
           <br />
        <FormGroup>
        <ControlLabel>
                <b>Jag har den utrustning jag behöver för att utföra mitt arbete</b> <span className="star">*</span>
        </ControlLabel>
        <br/>
        <Radio type='integer' value="4) Håller helt med" onClick={event => {this.setState({arbetsmiljo1: event.target.value, arbetsmiljo1Error: ''}); this.arbetsmiljo1IsValid = true;}} inline name="arbetsmiljo1">4) Håller helt med</Radio><br/>
        <Radio type='integer' value="3) Håller med till viss del" onClick={event => {this.setState({arbetsmiljo1: event.target.value, arbetsmiljo1Error: ''}); this.arbetsmiljo1IsValid = true;}} inline name="arbetsmiljo1">3) Håller med till viss del</Radio><br/>
        <Radio type='integer' value="2) Håller inte med" onClick={event => {this.setState({arbetsmiljo1: event.target.value, arbetsmiljo1Error: ''}); this.arbetsmiljo1IsValid = true;}} inline name="arbetsmiljo1">2) Håller inte med</Radio><br/>
        <Radio type='integer' value="1) Håller inte alls med" onClick={event => {this.setState({arbetsmiljo1: event.target.value, arbetsmiljo1Error: ''}); this.arbetsmiljo1IsValid = true;}} inline name="arbetsmiljo1">1) Håller inte alls med</Radio><br/>
            <span className="text-danger">{this.state.arbetsmiljo1Error}</span>
        </FormGroup>
        <br />
        <FormGroup>
        <ControlLabel>
                <b>Jag känner mig trygg på min arbetsplats</b> <span className="star">*</span>
        </ControlLabel>
        <br/>
        <Radio type='integer' value="4) Håller helt med" onClick={event => {this.setState({arbetsmiljo4: event.target.value, arbetsmiljo4Error: ''}); this.arbetsmiljo4IsValid = true;}} inline name="arbetsmiljo4">4) Håller helt med</Radio><br/>
        <Radio type='integer' value="3) Håller med till viss del" onClick={event => {this.setState({arbetsmiljo4: event.target.value, arbetsmiljo4Error: ''}); this.arbetsmiljo4IsValid = true;}} inline name="arbetsmiljo4">3) Håller med till viss del</Radio><br/>
        <Radio type='integer' value="2) Håller inte med" onClick={event => {this.setState({arbetsmiljo4: event.target.value, arbetsmiljo4Error: ''}); this.arbetsmiljo4IsValid = true;}} inline name="arbetsmiljo4">2) Håller inte med</Radio><br/>
        <Radio type='integer' value="1) Håller inte alls med" onClick={event => {this.setState({arbetsmiljo4: event.target.value, arbetsmiljo4Error: ''}); this.arbetsmiljo4IsValid = true;}} inline name="arbetsmiljo4">1) Håller inte alls med</Radio><br/>
            <span className="text-danger">{this.state.arbetsmiljo4Error}</span>
        </FormGroup>
        <br />
        <FormGroup>
        <ControlLabel>
                <b>På min arbetsplats bedrivs ett förebyggande arbete för att förhindra olycksfall och ohälsa</b> <span className="star">*</span>
        </ControlLabel>
        <br/>
        <Radio type='integer' value="4) Håller helt med" onClick={event => {this.setState({arbetsmiljo5: event.target.value, arbetsmiljo5Error: ''}); this.arbetsmiljo5IsValid = true;}} inline name="arbetsmiljo5">4) Håller helt med</Radio><br/>
        <Radio type='integer' value="3) Håller med till viss del" onClick={event => {this.setState({arbetsmiljo5: event.target.value, arbetsmiljo5Error: ''}); this.arbetsmiljo5IsValid = true;}} inline name="arbetsmiljo5">3) Håller med till viss del</Radio><br/>
        <Radio type='integer' value="2) Håller inte med" onClick={event => {this.setState({arbetsmiljo5: event.target.value, arbetsmiljo5Error: ''}); this.arbetsmiljo5IsValid = true;}} inline name="arbetsmiljo5">2) Håller inte med</Radio><br/>
        <Radio type='integer' value="1) Håller inte alls med" onClick={event => {this.setState({arbetsmiljo5: event.target.value, arbetsmiljo5Error: ''}); this.arbetsmiljo5IsValid = true;}} inline name="arbetsmiljo5">1) Håller inte alls med</Radio><br/>
            <span className="text-danger">{this.state.arbetsmiljo5Error}</span>
        </FormGroup>
        <br />
        <FormGroup>
        <ControlLabel>
                <b>Det hålls ordning och reda i personalutrymmen och allmänna utrymmen</b> <span className="star">*</span>
        </ControlLabel>
        <br/>
        <Radio type='integer' value="4) Håller helt med" onClick={event => {this.setState({arbetsmiljo6: event.target.value, arbetsmiljo6Error: ''}); this.arbetsmiljo6IsValid = true;}} inline name="arbetsmiljo6">4) Håller helt med</Radio><br/>
        <Radio type='integer' value="3) Håller med till viss del" onClick={event => {this.setState({arbetsmiljo6: event.target.value, arbetsmiljo6Error: ''}); this.arbetsmiljo6IsValid = true;}} inline name="arbetsmiljo6">3) Håller med till viss del</Radio><br/>
        <Radio type='integer' value="2) Håller inte med" onClick={event => {this.setState({arbetsmiljo6: event.target.value, arbetsmiljo6Error: ''}); this.arbetsmiljo6IsValid = true;}} inline name="arbetsmiljo6">2) Håller inte med</Radio><br/>
        <Radio type='integer' value="1) Håller inte alls med" onClick={event => {this.setState({arbetsmiljo6: event.target.value, arbetsmiljo6Error: ''}); this.arbetsmiljo6IsValid = true;}} inline name="arbetsmiljo6">1) Håller inte alls med</Radio><br/>
            <span className="text-danger">{this.state.arbetsmiljo6Error}</span>
        </FormGroup>
        <br />
        <FormGroup>
        <ControlLabel>
                <b>Totalt sett är jag nöjd med arbetsmiljön på min arbetsplats</b> <span className="star">*</span>
        </ControlLabel>
        <br/>
        <Radio type='integer' value="4) Håller helt med" onClick={event => {this.setState({arbetsmiljo7: event.target.value, arbetsmiljo7Error: ''}); this.arbetsmiljo7IsValid = true;}} inline name="arbetsmiljo7">4) Håller helt med</Radio><br/>
        <Radio type='integer' value="3) Håller med till viss del" onClick={event => {this.setState({arbetsmiljo7: event.target.value, arbetsmiljo7Error: ''}); this.arbetsmiljo7IsValid = true;}} inline name="arbetsmiljo7">3) Håller med till viss del</Radio><br/>
        <Radio type='integer' value="2) Håller inte med" onClick={event => {this.setState({arbetsmiljo7: event.target.value, arbetsmiljo7Error: ''}); this.arbetsmiljo7IsValid = true;}} inline name="arbetsmiljo7">2) Håller inte med</Radio><br/>
        <Radio type='integer' value="1) Håller inte alls med" onClick={event => {this.setState({arbetsmiljo7: event.target.value, arbetsmiljo7Error: ''}); this.arbetsmiljo7IsValid = true;}} inline name="arbetsmiljo7">1) Håller inte alls med</Radio><br/>
            <span className="text-danger">{this.state.arbetsmiljo7Error}</span>
        </FormGroup>
        <br />
        <FormGroup>
        <ControlLabel>
                <b>Jag upplever att arbetsmiljön på min arbetsplats har förbättrats en del under det senaste året</b> <span className="star">*</span>
        </ControlLabel>
        <br/>
        <Radio type='integer' value="JA" onClick={event => {this.setState({arbetsmiljo8: event.target.value, arbetsmiljo8Error: ''}); this.arbetsmiljo8IsValid = true;}} inline name="arbetsmiljo8">JA</Radio><br/>
        <Radio type='integer' value="NEJ" onClick={event => {this.setState({arbetsmiljo8: event.target.value, arbetsmiljo8Error: ''}); this.arbetsmiljo8IsValid = true;}} inline name="arbetsmiljo8">NEJ</Radio><br/>
        <Radio type='integer' value="OFÖRÄNDRAT" onClick={event => {this.setState({arbetsmiljo8: event.target.value, arbetsmiljo8Error: ''}); this.arbetsmiljo8IsValid = true;}} inline name="arbetsmiljo8">OFÖRÄNDRAT</Radio><br/>
        <Radio type='integer' value="VET EJ" onClick={event => {this.setState({arbetsmiljo8: event.target.value, arbetsmiljo8Error: ''}); this.arbetsmiljo8IsValid = true;}} inline name="arbetsmiljo8">VET EJ</Radio><br/>
            <span className="text-danger">{this.state.arbetsmiljo8Error}</span>
        </FormGroup>
        <br />
<FormGroup>
  <ControlLabel>
          <b>Förslag på åtgärder hur arbetsmiljön på min arbetsplats kan förbättras:</b>
  </ControlLabel>
  <FormControl
  componentClass="textarea" placeholder=""
  type="textarea"
  id="textfield"
  onChange={event => {this.setState({arbetsmiljo9: event.target.value});}}
  name="extraText"
  />
           </FormGroup>
<h2>Arbetskamrater och trivsel</h2>
        <br />
       <FormGroup>
        <ControlLabel>
                <b>Jag känner förtroende för mina arbetskamrater</b> <span className="star">*</span>
        </ControlLabel>
        <br/>
        <Radio type='integer' value="4) Håller helt med" onClick={event => {this.setState({arbetstriv3: event.target.value, arbetstriv3Error: ''}); this.arbetstriv3IsValid = true;}} inline name="arbetstriv3">4) Håller helt med</Radio><br/>
        <Radio type='integer' value="3) Håller med till viss del" onClick={event => {this.setState({arbetstriv3: event.target.value, arbetstriv3Error: ''}); this.arbetstriv3IsValid = true;}} inline name="arbetstriv3">3) Håller med till viss del</Radio><br/>
        <Radio type='integer' value="2) Håller inte med" onClick={event => {this.setState({arbetstriv3: event.target.value, arbetstriv3Error: ''}); this.arbetstriv3IsValid = true;}} inline name="arbetstriv3">2) Håller inte med</Radio><br/>
        <Radio type='integer' value="1) Håller inte alls med" onClick={event => {this.setState({arbetstriv3: event.target.value, arbetstriv3Error: ''}); this.arbetstriv3IsValid = true;}} inline name="arbetstriv3">1) Håller inte alls med</Radio><br/>
            <span className="text-danger">{this.state.arbetstriv3Error}</span>
        </FormGroup>
        <br />
        <FormGroup>
        <ControlLabel>
                <b>När jag berättar om mitt jobb för min familj/mina vänner är jag oftast positiv</b> <span className="star">*</span>
        </ControlLabel>
        <br/>
        <Radio type='integer' value="4) Håller helt med" onClick={event => {this.setState({arbetstriv4: event.target.value, arbetstriv4Error: ''}); this.arbetstriv4IsValid = true;}} inline name="arbetstriv4">4) Håller helt med</Radio><br/>
        <Radio type='integer' value="3) Håller med till viss del" onClick={event => {this.setState({arbetstriv4: event.target.value, arbetstriv4Error: ''}); this.arbetstriv4IsValid = true;}} inline name="arbetstriv4">3) Håller med till viss del</Radio><br/>
        <Radio type='integer' value="2) Håller inte med" onClick={event => {this.setState({arbetstriv4: event.target.value, arbetstriv4Error: ''}); this.arbetstriv4IsValid = true;}} inline name="arbetstriv4">2) Håller inte med</Radio><br/>
        <Radio type='integer' value="1) Håller inte alls med" onClick={event => {this.setState({arbetstriv4: event.target.value, arbetstriv4Error: ''}); this.arbetstriv4IsValid = true;}} inline name="arbetstriv4">1) Håller inte alls med</Radio><br/>
            <span className="text-danger">{this.state.arbetstriv4Error}</span>
        </FormGroup>
        <br />
        <FormGroup>
        <ControlLabel>
                <b>Totalt sett trivs jag bra på arbetsplatsen och med mina arbetskamrater</b> <span className="star">*</span>
        </ControlLabel>
        <br/>
        <Radio type='integer' value="4) Håller helt med" onClick={event => {this.setState({arbetstriv5: event.target.value, arbetstriv5Error: ''}); this.arbetstriv5IsValid = true;}} inline name="arbetstriv5">4) Håller helt med</Radio><br/>
        <Radio type='integer' value="3) Håller med till viss del" onClick={event => {this.setState({arbetstriv5: event.target.value, arbetstriv5Error: ''}); this.arbetstriv5IsValid = true;}} inline name="arbetstriv5">3) Håller med till viss del</Radio><br/>
        <Radio type='integer' value="2) Håller inte med" onClick={event => {this.setState({arbetstriv5: event.target.value, arbetstriv5Error: ''}); this.arbetstriv5IsValid = true;}} inline name="arbetstriv5">2) Håller inte med</Radio><br/>
        <Radio type='integer' value="1) Håller inte alls med" onClick={event => {this.setState({arbetstriv5: event.target.value, arbetstriv5Error: ''}); this.arbetstriv5IsValid = true;}} inline name="arbetstriv5">1) Håller inte alls med</Radio><br/>
            <span className="text-danger">{this.state.arbetstriv5Error}</span>
        </FormGroup>
        <br />
        <FormGroup>
        <ControlLabel>
                <b>Jag upplever att trivseln på arbetsplatsen totalt sett har blivit bättre under det senaste året</b> <span className="star">*</span>
        </ControlLabel>
        <br/>
        <Radio type='integer' value="JA" onClick={event => {this.setState({arbetstriv6: event.target.value, arbetstriv6Error: ''}); this.arbetstriv6IsValid = true;}} inline name="arbetstriv6">JA</Radio><br/>
        <Radio type='integer' value="NEJ" onClick={event => {this.setState({arbetstriv6: event.target.value, arbetstriv6Error: ''}); this.arbetstriv6IsValid = true;}} inline name="arbetstriv6">NEJ</Radio><br/>
        <Radio type='integer' value="OFÖRÄNDRAT" onClick={event => {this.setState({arbetstriv6: event.target.value, arbetstriv6Error: ''}); this.arbetstriv6IsValid = true;}} inline name="arbetstriv6">OFÖRÄNDRAT</Radio><br/>
        <Radio type='integer' value="VET EJ" onClick={event => {this.setState({arbetstriv6: event.target.value, arbetstriv6Error: ''}); this.arbetstriv6IsValid = true;}} inline name="arbetstriv6">VET EJ</Radio><br/>
            <span className="text-danger">{this.state.arbetstriv6Error}</span>
        </FormGroup>
        <br />
        <FormGroup>
  <ControlLabel>
          <b>Förslag på åtgärder för hur trivseln kollegor emellan kan förbättras på arbetsplatsen:</b>
  </ControlLabel>
  <FormControl
  componentClass="textarea" placeholder=""
  type="textarea"
  id="textfield"
  onChange={event => {this.setState({arbetstriv7: event.target.value});}}
  name="extraText"
  />
</FormGroup>
<h2>Ledarskapet</h2>
        <br />
        <FormGroup>
        <ControlLabel>
                <b>Jag är i stora drag nöjd med min närmsta chef</b> <span className="star">*</span>
        </ControlLabel>
        <br/>
        <Radio type='integer' value="4) Håller helt med" onClick={event => {this.setState({ledarskapet4: event.target.value, ledarskapet4Error: ''}); this.ledarskapet4IsValid = true;}} inline name="ledarskapet4">4) Håller helt med</Radio><br/>
        <Radio type='integer' value="3) Håller med till viss del" onClick={event => {this.setState({ledarskapet4: event.target.value, ledarskapet4Error: ''}); this.ledarskapet4IsValid = true;}} inline name="ledarskapet4">3) Håller med till viss del</Radio><br/>
        <Radio type='integer' value="2) Håller inte med" onClick={event => {this.setState({ledarskapet4: event.target.value, ledarskapet4Error: ''}); this.ledarskapet4IsValid = true;}} inline name="ledarskapet4">2) Håller inte med</Radio><br/>
        <Radio type='integer' value="1) Håller inte alls med" onClick={event => {this.setState({ledarskapet4: event.target.value, ledarskapet4Error: ''}); this.ledarskapet4IsValid = true;}} inline name="ledarskapet4">1) Håller inte alls med</Radio><br/>
            <span className="text-danger">{this.state.ledarskapet4Error}</span>
        </FormGroup>
        <br />
        <FormGroup>
        <ControlLabel>
                <b>Jag har förtroende för företagets VD</b> <span className="star">*</span>
        </ControlLabel>
        <br/>
        <Radio type='integer' value="4) Håller helt med" onClick={event => {this.setState({ledarskapet5: event.target.value, ledarskapet5Error: ''}); this.ledarskapet5IsValid = true;}} inline name="ledarskapet5">4) Håller helt med</Radio><br/>
        <Radio type='integer' value="3) Håller med till viss del" onClick={event => {this.setState({ledarskapet5: event.target.value, ledarskapet5Error: ''}); this.ledarskapet5IsValid = true;}} inline name="ledarskapet5">3) Håller med till viss del</Radio><br/>
        <Radio type='integer' value="2) Håller inte med" onClick={event => {this.setState({ledarskapet5: event.target.value, ledarskapet5Error: ''}); this.ledarskapet5IsValid = true;}} inline name="ledarskapet5">2) Håller inte med</Radio><br/>
        <Radio type='integer' value="1) Håller inte alls med" onClick={event => {this.setState({ledarskapet5: event.target.value, ledarskapet5Error: ''}); this.ledarskapet5IsValid = true;}} inline name="ledarskapet5">1) Håller inte alls med</Radio><br/>
            <span className="text-danger">{this.state.ledarskapet5Error}</span>
        </FormGroup>
        <br />
        <FormGroup>
        <ControlLabel>
                <b>Jag tycker att ledarskapet i mitt företag är bra totalt sett</b> <span className="star">*</span>
        </ControlLabel>
        <br/>
        <Radio type='integer' value="4) Håller helt med" onClick={event => {this.setState({ledarskapet6: event.target.value, ledarskapet6Error: ''}); this.ledarskapet6IsValid = true;}} inline name="ledarskapet6">4) Håller helt med</Radio><br/>
        <Radio type='integer' value="3) Håller med till viss del" onClick={event => {this.setState({ledarskapet6: event.target.value, ledarskapet6Error: ''}); this.ledarskapet6IsValid = true;}} inline name="ledarskapet6">3) Håller med till viss del</Radio><br/>
        <Radio type='integer' value="2) Håller inte med" onClick={event => {this.setState({ledarskapet6: event.target.value, ledarskapet6Error: ''}); this.ledarskapet6IsValid = true;}} inline name="ledarskapet6">2) Håller inte med</Radio><br/>
        <Radio type='integer' value="1) Håller inte alls med" onClick={event => {this.setState({ledarskapet6: event.target.value, ledarskapet6Error: ''}); this.ledarskapet6IsValid = true;}} inline name="ledarskapet6">1) Håller inte alls med</Radio><br/>
            <span className="text-danger">{this.state.ledarskapet6Error}</span>
        </FormGroup>
        <br />
        <FormGroup>
        <ControlLabel>
                <b>Jag upplever att ledarskapet i företaget har förbättrats under det senaste året</b> <span className="star">*</span>
        </ControlLabel>
        <br/>
        <Radio type='integer' value="JA" onClick={event => {this.setState({ledarskapet7: event.target.value, ledarskapet7Error: ''}); this.ledarskapet7IsValid = true;}} inline name="ledarskapet7">JA</Radio><br/>
        <Radio type='integer' value="NEJ" onClick={event => {this.setState({ledarskapet7: event.target.value, ledarskapet7Error: ''}); this.ledarskapet7IsValid = true;}} inline name="ledarskapet7">NEJ</Radio><br/>
        <Radio type='integer' value="OFÖRÄNDRAT" onClick={event => {this.setState({ledarskapet7: event.target.value, ledarskapet7Error: ''}); this.ledarskapet7IsValid = true;}} inline name="ledarskapet7">OFÖRÄNDRAT</Radio><br/>
        <Radio type='integer' value="VET EJ" onClick={event => {this.setState({ledarskapet7: event.target.value, ledarskapet7Error: ''}); this.ledarskapet7IsValid = true;}} inline name="ledarskapet7">VET EJ</Radio><br/>
            <span className="text-danger">{this.state.ledarskapet7Error}</span>
        </FormGroup>
        <br />
        <FormGroup>
  <ControlLabel>
          <b>Förslag på hur ledarskapet kan förbättras:</b>
  </ControlLabel>
  <FormControl
  componentClass="textarea" placeholder=""
  type="textarea"
  id="textfield"
  onChange={event => {this.setState({ledarskapet8: event.target.value});}}
  name="extraText"
  />
</FormGroup>
<h2>Arbetsuppgifter</h2>
<br />
<FormGroup>
        <ControlLabel>
                <b>Jag har god kännedom om vilka arbetsuppgifter jag förväntas göra</b> <span className="star">*</span>
        </ControlLabel>
        <br/>
        <Radio type='integer' value="4) Håller helt med" onClick={event => {this.setState({arbetsuppgifter1: event.target.value, arbetsuppgifter1Error: ''}); this.arbetsuppgifter1IsValid = true;}} inline name="arbetsuppgifter1">4) Håller helt med</Radio><br/>
        <Radio type='integer' value="3) Håller med till viss del" onClick={event => {this.setState({arbetsuppgifter1: event.target.value, arbetsuppgifter1Error: ''}); this.arbetsuppgifter1IsValid = true;}} inline name="arbetsuppgifter1">3) Håller med till viss del</Radio><br/>
        <Radio type='integer' value="2) Håller inte med" onClick={event => {this.setState({arbetsuppgifter1: event.target.value, arbetsuppgifter1Error: ''}); this.arbetsuppgifter1IsValid = true;}} inline name="arbetsuppgifter1">2) Håller inte med</Radio><br/>
        <Radio type='integer' value="1) Håller inte alls med" onClick={event => {this.setState({arbetsuppgifter1: event.target.value, arbetsuppgifter1Error: ''}); this.arbetsuppgifter1IsValid = true;}} inline name="arbetsuppgifter1">1) Håller inte alls med</Radio><br/>
            <span className="text-danger">{this.state.arbetsuppgifter1Error}</span>
        </FormGroup>
        <br />
        <FormGroup>
        <ControlLabel>
                <b> Jag känner ansvar för mitt arbetsområde och mina arbetsuppgifter</b> <span className="star">*</span>
        </ControlLabel>
        <br/>
        <Radio type='integer' value="4) Håller helt med" onClick={event => {this.setState({arbetsuppgifter4: event.target.value, arbetsuppgifter4Error: ''}); this.arbetsuppgifter4IsValid = true;}} inline name="arbetsuppgifter4">4) Håller helt med</Radio><br/>
        <Radio type='integer' value="3) Håller med till viss del" onClick={event => {this.setState({arbetsuppgifter4: event.target.value, arbetsuppgifter4Error: ''}); this.arbetsuppgifter4IsValid = true;}} inline name="arbetsuppgifter4">3) Håller med till viss del</Radio><br/>
        <Radio type='integer' value="2) Håller inte med" onClick={event => {this.setState({arbetsuppgifter4: event.target.value, arbetsuppgifter4Error: ''}); this.arbetsuppgifter4IsValid = true;}} inline name="arbetsuppgifter4">2) Håller inte med</Radio><br/>
        <Radio type='integer' value="1) Håller inte alls med" onClick={event => {this.setState({arbetsuppgifter4: event.target.value, arbetsuppgifter4Error: ''}); this.arbetsuppgifter4IsValid = true;}} inline name="arbetsuppgifter4">1) Håller inte alls med</Radio><br/>
            <span className="text-danger">{this.state.arbetsuppgifter4Error}</span>
        </FormGroup>
        <br />
        <FormGroup>
        <ControlLabel>
                <b> Totalt sett trivs jag bra med mina arbetsuppgifter</b> <span className="star">*</span>
        </ControlLabel>
        <br/>
        <Radio type='integer' value="4) Håller helt med" onClick={event => {this.setState({arbetsuppgifter5: event.target.value, arbetsuppgifter5Error: ''}); this.arbetsuppgifter5IsValid = true;}} inline name="arbetsuppgifter5">4) Håller helt med</Radio><br/>
        <Radio type='integer' value="3) Håller med till viss del" onClick={event => {this.setState({arbetsuppgifter5: event.target.value, arbetsuppgifter5Error: ''}); this.arbetsuppgifter5IsValid = true;}} inline name="arbetsuppgifter5">3) Håller med till viss del</Radio><br/>
        <Radio type='integer' value="2) Håller inte med" onClick={event => {this.setState({arbetsuppgifter5: event.target.value, arbetsuppgifter5Error: ''}); this.arbetsuppgifter5IsValid = true;}} inline name="arbetsuppgifter5">2) Håller inte med</Radio><br/>
        <Radio type='integer' value="1) Håller inte alls med" onClick={event => {this.setState({arbetsuppgifter5: event.target.value, arbetsuppgifter5Error: ''}); this.arbetsuppgifter5IsValid = true;}} inline name="arbetsuppgifter5">1) Håller inte alls med</Radio><br/>
            <span className="text-danger">{this.state.arbetsuppgifter5Error}</span>
        </FormGroup>
        <br />
        <FormGroup>
  <ControlLabel>
          <b>Förslag på åtgärder för hur mina arbetsuppgifter kan förbättras:</b>
  </ControlLabel>
  <FormControl
  componentClass="textarea" placeholder=""
  type="textarea"
  id="textfield"
  onChange={event => {this.setState({arbetsuppgifter6: event.target.value});}}
  name="extraText"
  />
</FormGroup>
<h2>Information</h2>
<br />
        <FormGroup>
        <ControlLabel>
                <b> Jag tycker att Min Sida innehåller relevant information</b> <span className="star">*</span>
        </ControlLabel>
        <br/>
        <Radio type='integer' value="4) Håller helt med" onClick={event => {this.setState({information6: event.target.value, information6Error: ''}); this.information6IsValid = true;}} inline name="information6">4) Håller helt med</Radio><br/>
        <Radio type='integer' value="3) Håller med till viss del" onClick={event => {this.setState({information6: event.target.value, information6Error: ''}); this.information6IsValid = true;}} inline name="information6">3) Håller med till viss del</Radio><br/>
        <Radio type='integer' value="2) Håller inte med" onClick={event => {this.setState({information6: event.target.value, information6Error: ''}); this.information6IsValid = true;}} inline name="information6">2) Håller inte med</Radio><br/>
        <Radio type='integer' value="1) Håller inte alls med" onClick={event => {this.setState({information6: event.target.value, information6Error: ''}); this.information6IsValid = true;}} inline name="information6">1) Håller inte alls med</Radio><br/>
            <span className="text-danger">{this.state.information6Error}</span>
        </FormGroup>
<br />
        <FormGroup>
        <ControlLabel>
                <b> Jag tycker att våra arbetsplatsträffar (APT) är givande</b> <span className="star">*</span>
        </ControlLabel>
        <br/>
        <Radio type='integer' value="4) Håller helt med" onClick={event => {this.setState({information7: event.target.value, information7Error: ''}); this.information7IsValid = true;}} inline name="information7">4) Håller helt med</Radio><br/>
        <Radio type='integer' value="3) Håller med till viss del" onClick={event => {this.setState({information7: event.target.value, information7Error: ''}); this.information7IsValid = true;}} inline name="information7">3) Håller med till viss del</Radio><br/>
        <Radio type='integer' value="2) Håller inte med" onClick={event => {this.setState({information7: event.target.value, information7Error: ''}); this.information7IsValid = true;}} inline name="information7">2) Håller inte med</Radio><br/>
        <Radio type='integer' value="1) Håller inte alls med" onClick={event => {this.setState({information7: event.target.value, information7Error: ''}); this.information7IsValid = true;}} inline name="information7">1) Håller inte alls med</Radio><br/>
            <span className="text-danger">{this.state.information7Error}</span>
        </FormGroup>
        <br />
        <FormGroup>
        <ControlLabel>
                <b> Jag kan i generella drag redogöra för företagets övergripande mål och vision</b> <span className="star">*</span>
        </ControlLabel>
        <br/>
        <Radio type='integer' value="4) Håller helt med" onClick={event => {this.setState({information3: event.target.value, information3Error: ''}); this.information3IsValid = true;}} inline name="information3">4) Håller helt med</Radio><br/>
        <Radio type='integer' value="3) Håller med till viss del" onClick={event => {this.setState({information3: event.target.value, information3Error: ''}); this.information3IsValid = true;}} inline name="information3">3) Håller med till viss del</Radio><br/>
        <Radio type='integer' value="2) Håller inte med" onClick={event => {this.setState({information3: event.target.value, information3Error: ''}); this.information3IsValid = true;}} inline name="information3">2) Håller inte med</Radio><br/>
        <Radio type='integer' value="1) Håller inte alls med" onClick={event => {this.setState({information3: event.target.value, information3Error: ''}); this.information3IsValid = true;}} inline name="information3">1) Håller inte alls med</Radio><br/>
            <span className="text-danger">{this.state.information3Error}</span>
        </FormGroup>
        <br />
        <FormGroup>
        <ControlLabel>
                <b>Jag tycker att informationen inom företaget har blivit bättre totalt sett under det senaste året</b> <span className="star">*</span>
        </ControlLabel>
        <br/>
        <Radio type='integer' value="JA" onClick={event => {this.setState({information4: event.target.value, information4Error: ''}); this.information4IsValid = true;}} inline name="information4">JA</Radio><br/>
        <Radio type='integer' value="NEJ" onClick={event => {this.setState({information4: event.target.value, information4Error: ''}); this.information4IsValid = true;}} inline name="information4">NEJ</Radio><br/>
        <Radio type='integer' value="OFÖRÄNDRAT" onClick={event => {this.setState({information4: event.target.value, information4Error: ''}); this.information4IsValid = true;}} inline name="information4">OFÖRÄNDRAT</Radio><br/>
        <Radio type='integer' value="VET EJ" onClick={event => {this.setState({information4: event.target.value, information4Error: ''}); this.information4IsValid = true;}} inline name="information4">VET EJ</Radio><br/>
            <span className="text-danger">{this.state.information4Error}</span>
        </FormGroup>
        <br />
        <FormGroup>
  <ControlLabel>
          <b>Förslag på åtgärder för hur informationen kan förbättras:</b>
  </ControlLabel>
  <FormControl
  componentClass="textarea" placeholder=""
  type="textarea"
  id="textfield"
  onChange={event => {this.setState({information5: event.target.value});}}
  name="extraText"
  />
</FormGroup>
<h2>Kunder</h2>
<br />
<FormGroup>
        <ControlLabel>
                        <b> Jag känner till våra kommersiella resor (tex programresor, konsert, teater, shopping, spa och kryssningar) och kan översikligt berätta om dem för kunder, vänner och bekanta</b> <span className="star">*</span>
        </ControlLabel>
        <br/>
        <Radio type='integer' value="4) Håller helt med" onClick={event => {this.setState({kunder1: event.target.value, kunder1Error: ''}); this.kunder1IsValid = true;}} inline name="kunder1">4) Håller helt med</Radio><br/>
        <Radio type='integer' value="3) Håller med till viss del" onClick={event => {this.setState({kunder1: event.target.value, kunder1Error: ''}); this.kunder1IsValid = true;}} inline name="kunder1">3) Håller med till viss del</Radio><br/>
        <Radio type='integer' value="2) Håller inte med" onClick={event => {this.setState({kunder1: event.target.value, kunder1Error: ''}); this.kunder1IsValid = true;}} inline name="kunder1">2) Håller inte med</Radio><br/>
        <Radio type='integer' value="1) Håller inte alls med" onClick={event => {this.setState({kunder1: event.target.value, kunder1Error: ''}); this.kunder1IsValid = true;}} inline name="kunder1">1) Håller inte alls med</Radio><br/>
            <span className="text-danger">{this.state.kunder1Error}</span>
        </FormGroup>
        <br />
        <FormGroup>
        <ControlLabel>
                <b> Jag känner till våra kunders önskemål och förväntningar</b> <span className="star">*</span>
        </ControlLabel>
        <br/>
        <Radio type='integer' value="4) Håller helt med" onClick={event => {this.setState({kunder2: event.target.value, kunder2Error: ''}); this.kunder2IsValid = true;}} inline name="kunder2">4) Håller helt med</Radio><br/>
        <Radio type='integer' value="3) Håller med till viss del" onClick={event => {this.setState({kunder2: event.target.value, kunder2Error: ''}); this.kunder2IsValid = true;}} inline name="kunder2">3) Håller med till viss del</Radio><br/>
        <Radio type='integer' value="2) Håller inte med" onClick={event => {this.setState({kunder2: event.target.value, kunder2Error: ''}); this.kunder2IsValid = true;}} inline name="kunder2">2) Håller inte med</Radio><br/>
        <Radio type='integer' value="1) Håller inte alls med" onClick={event => {this.setState({kunder2: event.target.value, kunder2Error: ''}); this.kunder2IsValid = true;}} inline name="kunder2">1) Håller inte alls med</Radio><br/>
            <span className="text-danger">{this.state.kunder2Error}</span>
        </FormGroup>
        <br />
        <FormGroup>
        <ControlLabel>
                <b> Inom företaget gör vi allt för att överträffa kundernas behov så snabbt och effektivt som möjligt</b> <span className="star">*</span>
        </ControlLabel>
        <br/>
        <Radio type='integer' value="4) Håller helt med" onClick={event => {this.setState({kunder3: event.target.value, kunder3Error: ''}); this.kunder3IsValid = true;}} inline name="kunder3">4) Håller helt med</Radio><br/>
        <Radio type='integer' value="3) Håller med till viss del" onClick={event => {this.setState({kunder3: event.target.value, kunder3Error: ''}); this.kunder3IsValid = true;}} inline name="kunder3">3) Håller med till viss del</Radio><br/>
        <Radio type='integer' value="2) Håller inte med" onClick={event => {this.setState({kunder3: event.target.value, kunder3Error: ''}); this.kunder3IsValid = true;}} inline name="kunder3">2) Håller inte med</Radio><br/>
        <Radio type='integer' value="1) Håller inte alls med" onClick={event => {this.setState({kunder3: event.target.value, kunder3Error: ''}); this.kunder3IsValid = true;}} inline name="kunder3">1) Håller inte alls med</Radio><br/>
            <span className="text-danger">{this.state.kunder3Error}</span>
        </FormGroup>
        <br />
        <FormGroup>
        <ControlLabel>
                <b> Jag rekommenderar våra produkter/tjänster till mina vänner och bekanta</b> <span className="star">*</span>
        </ControlLabel>
        <br/>
        <Radio type='integer' value="4) Håller helt med" onClick={event => {this.setState({kunder4: event.target.value, kunder4Error: ''}); this.kunder4IsValid = true;}} inline name="kunder4">4) Håller helt med</Radio><br/>
        <Radio type='integer' value="3) Håller med till viss del" onClick={event => {this.setState({kunder4: event.target.value, kunder4Error: ''}); this.kunder4IsValid = true;}} inline name="kunder4">3) Håller med till viss del</Radio><br/>
        <Radio type='integer' value="2) Håller inte med" onClick={event => {this.setState({kunder4: event.target.value, kunder4Error: ''}); this.kunder4IsValid = true;}} inline name="kunder4">2) Håller inte med</Radio><br/>
        <Radio type='integer' value="1) Håller inte alls med" onClick={event => {this.setState({kunder4: event.target.value, kunder4Error: ''}); this.kunder4IsValid = true;}} inline name="kunder4">1) Håller inte alls med</Radio><br/>
            <span className="text-danger">{this.state.kunder4Error}</span>
        </FormGroup>
        <br />
        <FormGroup>
  <ControlLabel>
          <b>Förslag på åtgärder för hur kännedomen om företagets kunder, produkter och tjänster kan förbättras:</b>
  </ControlLabel>
  <FormControl
  componentClass="textarea" placeholder=""
  type="textarea"
  id="textfield"
  onChange={event => {this.setState({kunder5: event.target.value});}}
  name="extraText"
  />
</FormGroup>
<h2>Företaget</h2>
<br />
<FormGroup>
        <ControlLabel>
                <b> Jag är stolt över att arbeta i företaget</b> <span className="star">*</span>
        </ControlLabel>
        <br/>
        <Radio type='integer' value="4) Håller helt med" onClick={event => {this.setState({foretaget1: event.target.value, foretaget1Error: ''}); this.foretaget1IsValid = true;}} inline name="foretaget1">4) Håller helt med</Radio><br/>
        <Radio type='integer' value="3) Håller med till viss del" onClick={event => {this.setState({foretaget1: event.target.value, foretaget1Error: ''}); this.foretaget1IsValid = true;}} inline name="foretaget1">3) Håller med till viss del</Radio><br/>
        <Radio type='integer' value="2) Håller inte med" onClick={event => {this.setState({foretaget1: event.target.value, foretaget1Error: ''}); this.foretaget1IsValid = true;}} inline name="foretaget1">2) Håller inte med</Radio><br/>
        <Radio type='integer' value="1) Håller inte alls med" onClick={event => {this.setState({foretaget1: event.target.value, foretaget1Error: ''}); this.foretaget1IsValid = true;}} inline name="foretaget1">1) Håller inte alls med</Radio><br/>
            <span className="text-danger">{this.state.foretaget1Error}</span>
        </FormGroup>
        <br />
        <FormGroup>
        <ControlLabel>
                <b> Jag skulle rekommendera mitt företag som en bra arbetsgivare till mina vänner och bekanta</b> <span className="star">*</span>
        </ControlLabel>
        <br/>
        <Radio type='integer' value="4) Håller helt med" onClick={event => {this.setState({foretaget2: event.target.value, foretaget2Error: ''}); this.foretaget2IsValid = true;}} inline name="foretaget2">4) Håller helt med</Radio><br/>
        <Radio type='integer' value="3) Håller med till viss del" onClick={event => {this.setState({foretaget2: event.target.value, foretaget2Error: ''}); this.foretaget2IsValid = true;}} inline name="foretaget2">3) Håller med till viss del</Radio><br/>
        <Radio type='integer' value="2) Håller inte med" onClick={event => {this.setState({foretaget2: event.target.value, foretaget2Error: ''}); this.foretaget2IsValid = true;}} inline name="foretaget2">2) Håller inte med</Radio><br/>
        <Radio type='integer' value="1) Håller inte alls med" onClick={event => {this.setState({foretaget2: event.target.value, foretaget2Error: ''}); this.foretaget2IsValid = true;}} inline name="foretaget2">1) Håller inte alls med</Radio><br/>
            <span className="text-danger">{this.state.foretaget2Error}</span>
        </FormGroup>
        <br />
        <FormGroup>
  <ControlLabel>
          <b>Vilka är dina förväntningar på ditt företag för framtiden?</b>
  </ControlLabel>
  <FormControl
  componentClass="textarea" placeholder=""
  type="textarea"
  id="textfield"
  onChange={event => {this.setState({foretaget3: event.target.value});}}
  name="extraText"
  />
</FormGroup>
<br />
<FormGroup>
  <ControlLabel>
          <b>Har du någonting annat som du vill framföra till företagsledningen?</b>
  </ControlLabel>
  <FormControl
  componentClass="textarea" placeholder=""
  type="textarea"
  id="textfield"
  onChange={event => {this.setState({foretaget4: event.target.value});}}
  name="extraText"
  />
</FormGroup>
{/*<h2>Utvecklingsprojekt</h2>*/}
{/*<p>Under det senaste året har vi genomfört två större utvecklingsprojekt – skadeförebyggande arbete tillsammans med Trygg Hansa samt Sparsam körning - och vi vill gärna veta mer om hur du har upplevt dem hittills och hur du skulle önska att vi arbetar vidare med dem.</p>*/}
{/*<br />*/}
{/*<FormGroup>*/}
{/*  <ControlLabel>*/}
{/*          <b>I november 2019 lanserade vi en ny funktion i Min Sida för inrapportering av fordonsskador och möjligheten att följa sina egna och trafikområdets försäkringsärenden och kostnader månadsvis. Inför detta åkte företagsledningen tillsammans med försäkringsbolaget Trygg Hansa runt på depåerna för att informera om försäkringen, den nya digitala skaderapporten, vår nya förebyggande rutin med skadesamtal och coachning samt den depåtävling som skulle genomföras under 6 månader som en kickstart på projektet. Nu vill vi veta hur du har upplevt det första året med digital skaderapportering och uppföljning via Min Sida. Dela gärna med dig om du har tankar och önskemål kring hur vi kan jobba vidare för att minska frekvensen skador och hålla den fortsatt låg.</b>*/}
{/*  </ControlLabel>*/}
{/*  <FormControl*/}
{/*  componentClass="textarea" placeholder=""*/}
{/*  type="textarea"*/}
{/*  id="textfield"*/}
{/*  onChange={event => {this.setState({utvecklingsprojekt1: event.target.value});}}*/}
{/*  name="extraText"*/}
{/*  />*/}
{/*</FormGroup>*/}
{/*<br />*/}
{/*<FormGroup>*/}
{/*  <ControlLabel>*/}
{/*          <b>I början på 2020 smög vi igång med ännu en nyhet i Min Sida, nämligen möjligheten för bussförare att följa sin drivmedelsförbrukning. Nu planerar vi för att ta projektet Sparsam körning till nästa nivå. Vi tar gärna dina tankar och tips kring hur vi kan göra det på bästa sätt för att minska vår miljöpåverkan och våra drivmedelskostnader.</b>*/}
{/*  </ControlLabel>*/}
{/*  <FormControl*/}
{/*  componentClass="textarea" placeholder=""*/}
{/*  type="textarea"*/}
{/*  id="textfield"*/}
{/*  onChange={event => {this.setState({utvecklingsprojekt2: event.target.value});}}*/}
{/*  name="extraText"*/}
{/*  />*/}
{/*    </FormGroup>*/}
{/*    <FormGroup>*/}
{/*  <ControlLabel>*/}
{/*          <b>Vill du framföra något annat till företagsledningen eller förtydliga/kommentera något till dina svar på de 5 ovanstående frågorna?</b>*/}
{/*  </ControlLabel>*/}
{/*  <FormControl*/}
{/*  componentClass="textarea" placeholder=""*/}
{/*  type="textarea"*/}
{/*  id="textfield"*/}
{/*  onChange={event => {this.setState({kortfri1: event.target.value});}}*/}
{/*  name="extraText"*/}
{/*  />*/}
{/*    </FormGroup>*/}
<br />
<FormGroup>
    <SavingButton
            text="Spara"
            inProgressText="Sparar.."
            completeMessage= {this.state.buttonmessage}
            errorMessage={this.state.buttonerror2}
            status={this.state.savingStatus}
            onClick={this.handleFormSave}
        />
        <span className="text-danger">{this.state.buttonerror}</span>
</FormGroup>

</form>
    </div>
    )
    }


}

function mapStateToProps(state) {
    return {
        user: state.oidc.user,
    };
  }

export default connect(mapStateToProps, { getUndersokning})(Tjansteman);
